import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useLanguage } from '../../../../contexts/LanguageContext';

const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('tr-TR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
};

const formatQuantity = (value) => {
    if (value == null) return '-';
    return new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    }).format(value);
};

const DealerStockAddTable = ({
    rows = [],
    loading = false,
    totalCount = 0,
    pagination = { PageNumber: 1, PageSize: 10 },
    onPageChange
}) => {
    const { th } = useLanguage();

    const dateTemplate = (rowData) => (
        <span>{formatDate(rowData.createdDate)}</span>
    );

    const quantityTemplate = (rowData) => (
        <span className="font-semibold">{formatQuantity(rowData.quantity)}</span>
    );

    return (
        <DataTable
            value={rows}
            dataKey="id"
            lazy
            paginator
            first={(pagination.PageNumber - 1) * pagination.PageSize}
            rows={pagination.PageSize}
            totalRecords={totalCount}
            onPage={onPageChange}
            loading={loading}
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            tableStyle={{ minWidth: '60rem' }}
            showGridlines
            stripedRows
            emptyMessage={th('dealerStockAdd.table.empty')}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate={th('table.paginatorTemplate')}
        >
            <Column
                field="partCode"
                header={th('dealerStockAdd.table.partCode')}
                style={{ width: '15%' }}
            />
            <Column
                field="uom"
                header={th('dealerStockAdd.table.uom')}
                style={{ width: '8%' }}
            />
            <Column
                field="quantity"
                header={th('dealerStockAdd.table.quantity')}
                body={quantityTemplate}
                style={{ width: '10%' }}
            />
            <Column
                field="description"
                header={th('dealerStockAdd.table.description')}
                style={{ width: '20%' }}
            />
            <Column
                field="bosBranchCode"
                header={th('dealerStockAdd.table.branchCode')}
                style={{ width: '12%' }}
            />
            <Column
                field="createdName"
                header={th('dealerStockAdd.table.createdBy')}
                style={{ width: '15%' }}
            />
            <Column
                field="createdDate"
                header={th('dealerStockAdd.table.createdDate')}
                body={dateTemplate}
                style={{ width: '15%' }}
            />
        </DataTable>
    );
};

export default DealerStockAddTable;
